module.exports = __webpack_public_path__ + "static/media/05-intro.1e7fd303.png";